// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__287Ip","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1A2SW"};